import { Component, Inject } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-delete-package',
  templateUrl: './delete-package.component.html',
  styleUrls: ['./delete-package.component.scss'],
  standalone: false,
})
export class DeletePackageComponent {
  constructor(
    public dialogRef: MatDialogRef<DeletePackageComponent>,
    @Inject(MAT_DIALOG_DATA) public data: any,
  ) {}

  cancel() {
    this.dialogRef.close(false);
  }

  delete() {
    this.dialogRef.close(true);
  }
}
